import { call, put, takeLatest } from "redux-saga/effects";

import {
	PlaygroundNewAction,
	PlaygroundNewFailedAction,
	PlaygroundNewRequestAction,
	PlaygroundNewSuccessAction
} from "../../actions/playground/new";
import { postPlaygroundCreate } from "../../api/playground/new";
import { PlaygroundListAction } from "../../actions/playground/list";

/// / Playground New
// Worker
function * newPlaygroundWorker (action) {
	try {
		yield put(PlaygroundNewRequestAction());

		const r = yield call(postPlaygroundCreate, action.payload);
		if (r.json) {
			yield put(PlaygroundNewSuccessAction(r.json));

			// Reload playground list
			yield put(PlaygroundListAction());
		} else {
			yield put(PlaygroundNewFailedAction("Failed to post playground create"));
		}
	} catch (e) {
		yield put(PlaygroundNewFailedAction(e));
	}
}

// Saga
export function * newPlaygroundSaga () {
	yield takeLatest(PlaygroundNewAction.getType(), newPlaygroundWorker);
}

// Export

export const newSagas = [
	newPlaygroundSaga()
];

export default newSagas;
